import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpModule, Http } from '@angular/http';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgDraggableModule } from 'angular-draggable';


import {AuthHttpService  , UserService , AppDataService , CompanyService,SymplaService,WalletService,ExcelService, QuestsService, TranslationService } from './services/index';
import { Routes, RouterModule } from '@angular/router';
import { SasModule } from './sas/sas.module';
import { AppRoutingModule } from './app-routing.module';
import {EasyLoginModule} from './components/+easylogin/easylogin.module';
import {HeaderFooterModule} from './components/+header-footer/header.footer.module';
import {GameEventModule} from './components/+gameevent/gameevent.module';
import {InstagramModule} from './components/+integrationCode/instagram.module';
//import {UserAwardModule} from './components/+userawardcomponent/useraward.module';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { CommonModule } from '@angular/common';
import { MessagingService } from './messaging.service';
import {TranslateModule} from "./translate-module";
import {OfficeModule} from "./components/office-screens/office.module";
import {ModalModule} from "./components/Modals/modal.module";
import {LandingPageModule} from "./components/landing-page/landing-page.module"
import { TreinamentoModule } from './components/treinamento/treinamento.module';
import { PainelAlunoComponent } from './components/painel-aluno/painel-aluno.component';
import { LivetourModule } from './components/livetour/livetour.module';
import { SocialModule } from './components/social/social.module';

@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
  BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),
    FormsModule,
    CommonModule,
    SasModule,
    NgDraggableModule,
    ReactiveFormsModule,
    TranslateModule,
    HttpModule,
    RouterModule,
    NguiAutoCompleteModule,
    AppRoutingModule,
    GameEventModule,
    OfficeModule,
    InstagramModule,
    LivetourModule,
    EasyLoginModule,
    HeaderFooterModule,
    SocialModule,
//    UserAwardModule,
    ModalModule,
    LandingPageModule,
    TreinamentoModule
  ],
  providers: [
    AppDataService,
    CompanyService,
    SymplaService,
    AuthHttpService,
    UserService,
    ExcelService,
    QuestsService,
    TranslationService,
    WalletService,
    MessagingService,
    Title,

  ],
  exports : [
    ReactiveFormsModule,
    TranslateModule,
    EasyLoginModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/app.module.ts